import styled from 'styled-components';

export const LabelContainer = styled.label`
    font-size: 14px;
    font-weight: 500;
    color: hsl(var(--foreground));
    line-height: 1;
    display: inline-flex;
    align-items: center;
    gap: 0;
`;

export const RequiredAsterisk = styled.span`
    color: hsl(var(--destructive));
    margin-left: 4px;
`;

export const DescriptionText = styled.div`
    font-size: 14px;
    color: hsl(var(--muted-foreground));
    margin-top: 6px;
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
`;
